import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Offer} from '../../../../models/Offer';
import Marker = google.maps.Marker;
import {TranslatableString} from '../../../../models/TranslatableString';
import {Field} from './Field';

@Component({
  selector: 'app-offer-filter',
  templateUrl: './offer-filter.component.html',
  styleUrls: ['./offer-filter.component.scss']
})
export class OfferFilterComponent implements OnInit {
  @Input() offers: Array<Offer>;
  @Input() markers: Array<Marker>;
  @Output() close: EventEmitter<any>;

  @ViewChild('priceFrom') priceFrom: ElementRef;
  @ViewChild('priceTo') priceTo: ElementRef;
  @ViewChild('areaFrom') areaFrom: ElementRef;
  @ViewChild('areaTo') areaTo: ElementRef;
  @ViewChild('offerID') id: ElementRef;

  private isFirstClickRegions = true;
  private isFirstClickType = true;
  private isFirstClickSaleOption = true;

  regionField: Field;
  regions: Array<Field>;

  private centralAreas = ['ВИНС', 'Генералите', 'Гръцка махала', 'Общината', 'Червен площад', 'Чаталджа', 'Нептун',
    'Образцов дом', 'Централна поща', 'Бизнес хотел', 'Операта', 'ЖП гара'];

  typeField: Field;
  types: Array<{ type: Field, subTypes: Array<Field> }>;
  currentlySelectedType: { type: Field, subTypes: Array<Field> };

  salesSelected: boolean;
  rentsSelected: boolean;

  constructor() {
    this.regionField = new Field(new TranslatableString('Area', 'Area', 'Район', 'Район'), false);
    this.typeField = new Field(new TranslatableString('Type', 'Type', 'Тип', 'Тип'), false);
    this.salesSelected = true;
    this.rentsSelected = true;
    this.regions = [];
    this.types = [];
    this.close = new EventEmitter();
  }

  ngOnInit() {
    this.createDropdownValues();
  }

  private createDropdownValues() {
    const dummyRegions = [];
    const dummyTypes = [];
    const dummySubtypes = [];
    this.offers.forEach((offer: Offer) => {
      if (!dummyRegions.includes(offer.area.value)) {
        dummyRegions.push(offer.area.value);
        this.regions.push(new Field(new TranslatableString(offer.area.value, offer.area.valueEn, offer.area.valueBg, offer.area.valueRu)));
      }
      if (!dummyTypes.includes(offer.type.value)) {
        dummyTypes.push(offer.type.value);
        this.types.push({
          type: new Field(new TranslatableString(offer.type.value, offer.type.valueEn, offer.type.valueBg, offer.type.valueRu)),
          subTypes: [new Field(
            new TranslatableString(offer.subType.value, offer.subType.valueEn, offer.subType.valueBg, offer.subType.valueRu))
          ]
        });
        dummySubtypes.push(offer.subType.value);
      } else {
        if (!dummySubtypes.includes(offer.subType.value)) {
          dummySubtypes.push(offer.subType.value);
          const typeIndex = dummyTypes.indexOf(offer.type.value);
          this.types[typeIndex].subTypes.push(new Field(
            new TranslatableString(offer.subType.value, offer.subType.valueEn, offer.subType.valueBg, offer.subType.valueRu))
          );
        }
      }
    });

    this.regions.sort((x: Field, y: Field) => {
      return x.value.valueBg < y.value.valueBg ? -1 : 1;
    });

    this.types.forEach((type: { type: Field, subTypes: Array<Field> }) => {
      type.subTypes.sort((x: Field, y: Field) => {
        return x.value.valueBg < y.value.valueBg ? -1 : 1;
      });
    });
    this.currentlySelectedType = this.types[0];
    this.types[0].type.isSelected = true;
  }

  selectOfferType(type: { type: Field, subTypes: Array<Field> }) {
    this.currentlySelectedType = type;
  }

  toggleSelected(field: Field, toggleType: string) {
    if (this.isFirstClickRegions && toggleType === 'region') {
      this.isFirstClickRegions = false;
      this.regions.forEach((f: Field) => {
        f.isSelected = false;
      });
      field.isSelected = true;
    } else if (this.isFirstClickType && toggleType === 'type') {
      this.isFirstClickType = false;
      this.types.forEach((type) => {
        type.subTypes.forEach((subType) => {
          subType.isSelected = false;
        });
      });
      field.isSelected = true;
    } else {
      field.isSelected = !field.isSelected;
    }
    this.checkCenterAreaClick(field, toggleType);
    this.filterOffers();
  }

  private checkCenterAreaClick(field: Field, toggleType: string) {
    if (toggleType === 'region' && field.value.valueBg === 'Център') {
      this.regions.filter((f: Field) => {
        return this.centralAreas.includes(f.value.valueBg);
      }).forEach((f: Field) => {
        f.isSelected = field.isSelected;
      });
    }
  }

  toggleSales() {
    if (this.isFirstClickSaleOption) {
      this.isFirstClickSaleOption = false;
      this.salesSelected = true;
      this.rentsSelected = false;
    } else {
      this.salesSelected = !this.salesSelected;
    }
    this.filterOffers();
  }

  toggleRents() {
    if (this.isFirstClickSaleOption) {
      this.isFirstClickSaleOption = false;
      this.salesSelected = false;
      this.rentsSelected = true;
    } else {
      this.rentsSelected = !this.rentsSelected;
    }
    this.filterOffers();
  }

  filterOffers() {
    for (let i = 0; i < this.markers.length; i++) {
      const currentOffer = this.offers[i];
      const currentMarker = this.markers[i];
      currentMarker.setVisible(true);

      this.checkPrice(currentOffer, currentMarker);
      this.checkArea(currentOffer, currentMarker);
      this.checkRegion(currentOffer, currentMarker);
      this.checkSubtypeSelected(currentOffer, currentMarker);
      this.checkSalesAndRents(currentOffer, currentMarker);
      this.checkOfferID(currentOffer, currentMarker);
    }
  }

  private checkPrice(currentOffer: Offer, currentMarker: google.maps.Marker) {
    const priceFrom = Number(this.priceFrom.nativeElement.value);
    const priceTo = Number(this.priceTo.nativeElement.value);
    const offerPrice = Number(currentOffer.price.replace(' ', ''));

    if (priceFrom && offerPrice < priceFrom) {
      currentMarker.setVisible(false);
    }

    if (priceTo && offerPrice > priceTo) {
      currentMarker.setVisible(false);
    }
  }

  private checkArea(currentOffer: Offer, currentMarker: google.maps.Marker) {
    const areaFrom = Number(this.areaFrom.nativeElement.value);
    const areaTo = Number(this.areaTo.nativeElement.value);
    const offerArea = Number(currentOffer.space);

    if (areaFrom && offerArea < areaFrom) {
      currentMarker.setVisible(false);
    }

    if (areaTo && offerArea > areaTo) {
      currentMarker.setVisible(false);
    }
  }

  private checkRegion(currentOffer: Offer, currentMarker: google.maps.Marker) {
    const selectedRegions = this.regions.filter((region: Field) => {
      return region.isSelected && region.value.value === currentOffer.area.value;
    });

    if (selectedRegions.length === 0) {
      currentMarker.setVisible(false);
    }
  }

  private checkSubtypeSelected(currentOffer: Offer, currentMarker: google.maps.Marker) {
    const elementsMatching = [];
    this.types.forEach((type: { type: Field, subTypes: Array<Field> }) => {
      const selected = type.subTypes.filter((subType: Field) => {
        return subType.isSelected && subType.value.valueEn === currentOffer.subType.valueEn;
      });
      elementsMatching.push(...selected);
    });

    if (elementsMatching.length === 0) {
      currentMarker.setVisible(false);
    }
  }

  private checkOfferID(currentOffer: Offer, currentMarker: google.maps.Marker) {
    const id = Number(this.id.nativeElement.value);
    if (id && currentOffer.id !== id) {
      currentMarker.setVisible(false);
    }
  }

  private checkSalesAndRents(currentOffer: Offer, currentMarker: google.maps.Marker) {
    if (!this.salesSelected && currentOffer.isSellable) {
      currentMarker.setVisible(false);
    }
    if (!this.rentsSelected && currentOffer.isRentable) {
      currentMarker.setVisible(false);
    }
  }

  closeMenu() {
    this.close.emit();
  }
}
